import type { IAddressSuggestionConstructorParams } from "@services/sdk";
import type { ID } from "@services/sdk/types";
import { map } from "ramda";

import { formatAddress } from "@helpers/address-formatter.helper";

class AddressSuggestion {
	public static ConstructList(
		arrParams: Array<IAddressSuggestionConstructorParams>,
	): Array<AddressSuggestion> {
		return map(AddressSuggestion.Construct)(arrParams);
	}

	public static Construct(
		params: IAddressSuggestionConstructorParams,
	): AddressSuggestion {
		return new AddressSuggestion({
			address: formatAddress(params.address),
			id: params.id,
		});
	}

	responseData: IAddressSuggestionConstructorParams;

	constructor(params: IAddressSuggestionConstructorParams) {
		this.responseData = params;
	}

	get address(): string {
		return this.responseData.address;
	}

	get id(): ID {
		return this.responseData.id;
	}
}

export default AddressSuggestion;
